import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
/**
 * Rendering Mode CSS Loader
 *
 * This utility loads the appropriate CSS files based on the current rendering mode
 * (widget, fullscreen, inline) from the render.d directory.
 */

import Logger from '@/libs/Logger';
import GlobalApi from '@/libs/GlobalApi';
var log = Logger.namespace('rendering-mode-loader');

/**
 * Load the rendering mode-specific CSS file
 * @param {string} cssFile - The CSS file to load (default is 'default.css')
 * @returns {Promise<void>} - A promise that resolves when the CSS is loaded
 */
export function loadRenderingModeCSS() {
  return _loadRenderingModeCSS.apply(this, arguments);
}

// This function is kept for reference but not used directly
// eslint-disable-next-line no-unused-vars
function _loadRenderingModeCSS() {
  _loadRenderingModeCSS = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var cssFile,
      api,
      renderingMode,
      themeManager,
      _context3,
      _context4,
      fullPath,
      normalizedPath,
      baseUrl,
      pathParts,
      cssUrl,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          cssFile = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'default.css';
          api = GlobalApi.singleton();
          renderingMode = api.renderingMode || 'widget'; // Default to widget if not set
          log.info("Loading CSS for rendering mode: ".concat(renderingMode));

          // Get the ThemeManager instance
          themeManager = api.themes || window.kiwi.themes;
          if (!(themeManager && typeof themeManager.setRenderingMode === 'function')) {
            _context5.next = 1;
            break;
          }
          // Use the ThemeManager to load the rendering mode
          themeManager.setRenderingMode(renderingMode);
          log.info("Using ThemeManager to load rendering mode: ".concat(renderingMode));
          return _context5.abrupt("return", _Promise.resolve());
        case 1:
          log.info('ThemeManager not available, falling back to legacy mode');

          // Determine the base path for static resources
          // Get the full path without the hostname and protocol
          fullPath = window.location.pathname; // Remove trailing slash if present
          normalizedPath = _endsWithInstanceProperty(fullPath).call(fullPath, '/') ? _sliceInstanceProperty(fullPath).call(fullPath, 0, -1) : fullPath; // Extract the application root path (e.g., /relayos-kiwiirc/)
          baseUrl = '/'; // Check if we're in a path that starts with /relayos-kiwiirc/
          if (_includesInstanceProperty(normalizedPath).call(normalizedPath, '/relayos-kiwiirc')) {
            baseUrl = '/relayos-kiwiirc/';
            log.info("Using fixed application root path: ".concat(baseUrl));
          } else {
            // For other cases, extract the first path segment
            pathParts = normalizedPath.split('/');
            if (pathParts.length > 1 && pathParts[1]) {
              baseUrl = '/' + pathParts[1] + '/';
              log.info("Using detected application root path: ".concat(baseUrl));
            }
          }

          // Construct the CSS URL based on the rendering mode
          cssUrl = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "".concat(baseUrl, "render.d/")).call(_context4, renderingMode, "/")).call(_context3, cssFile);
          log.info("Loading CSS from: ".concat(cssUrl));
          return _context5.abrupt("return", new _Promise(function (resolve, reject) {
            // Create a link element for the CSS
            var linkElement = document.createElement('link');
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            linkElement.href = cssUrl;

            // Set up event handlers
            linkElement.onload = function () {
              log.info("Successfully loaded CSS for rendering mode: ".concat(renderingMode));
              resolve();
            };
            linkElement.onerror = function (error) {
              log.error("Failed to load CSS for rendering mode: ".concat(renderingMode), error);
              reject(error);
            };

            // Add the link element to the document head
            document.head.appendChild(linkElement);
          }));
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee);
  }));
  return _loadRenderingModeCSS.apply(this, arguments);
}
function loadCSSFallback(baseUrl, renderingMode, cssFile) {
  var _context, _context2;
  // Construct the CSS URL based on the rendering mode
  var cssUrl = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(baseUrl, "render.d/")).call(_context2, renderingMode, "/")).call(_context, cssFile);
  log.info("Falling back to legacy CSS from: ".concat(cssUrl));

  // Create a link element for the CSS
  var linkElement = document.createElement('link');
  linkElement.rel = 'stylesheet';
  linkElement.type = 'text/css';
  linkElement.href = cssUrl;

  // Set up event handlers
  linkElement.onload = function () {
    log.info("Successfully loaded legacy CSS for rendering mode: ".concat(renderingMode));
  };
  linkElement.onerror = function (error) {
    log.error("Failed to load legacy CSS for rendering mode: ".concat(renderingMode), error);
  };

  // Add the link element to the document head
  document.head.appendChild(linkElement);
}
export default {
  loadRenderingModeCSS: loadRenderingModeCSS
};